const CommonSessionChooseCompanyEnum = Object.freeze({
    ALL_COMPANY: { value: 'all_company', text: 'すべての企業' },
    SPECIFIC_COMPANIES: { value: 'specific_companies', text: '特定の企業のみ' },
});

export default CommonSessionChooseCompanyEnum;
